import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FrameSvg from '../../../../assets/img/frame.svg';

const planDetails = [
  { key: 'User Limit', value: [] },
  {
    key: 'Gem Image & Profile',
    value: [
      {
        text: 'Cloud storage + unlimited access to gemstone record (Source : User Own Device)',
        showIcon: false,
      },
      { text: 'Image Capturing (extracted from frame of video)', showIcon: false },
      { text: 'Cloud storage + unlimited access to gemstone record (Source : KRISTA™/KROMA™)', showIcon: false },
    ],
  },
  {
    key: 'Gem3D™ Video',
    value: [
      { text: 'Video capturing ', showIcon: false },
      { text: 'Cloud storage + unlimited access to video record', showIcon: false },
    ],
  },
  {
    key: 'GemPASSPORT™',
    value: [
      { text: 'Production of GemPASSPORT™', showIcon: true },
      { text: 'Cloud storage + unlimited access to GemPASSPORT™', showIcon: false },
    ],
    icon: true,
  },
  {
    key: 'GemPASSPORT™',
    value: [
      { text: 'Production of GemPASSPORT™', showIcon: false },
      { text: 'Cloud storage + unlimited access to GemPASSPORT™', showIcon: false },
    ],
  },
  { key: 'Verify GemPASSPORT™', value: [] },
];

type IPlanDetailsProps = {
  viewOnly?: boolean;
};

function PlanDetails({ viewOnly }: IPlanDetailsProps) {
  return (
    <Grid
      display="flex"
      flexDirection="column"
      alignItems="left"
      flex="1 1 auto"
      gap={2.5}
      py={20}
      pb={viewOnly ? 0 : 20}
    >
      {planDetails.map(({ key, value, icon }, i) => (
        <Grid key={key} display="flex" flexDirection="column" gap={2.5}>
          <Grid display="flex" gap={1.5} flexDirection="column">
            <Grid display="flex" alignItems="center" gap={1}>
              <Typography data-testid="heading" variant="tableheadBoldSm" color="#14181F">
                {key}
              </Typography>
              {icon && <Box component="img" src={FrameSvg} alt="Icon" sx={{ width: 12, height: 12 }} />}
            </Grid>
            {i === 0 && <div style={{ height: '0.5px', backgroundColor: '#DCE0E5', width: '100%' }} />}
            {value.length > 0 &&
              value.map((content, _index) => (
                <>
                  <Grid key={content.text} display="flex" flexDirection="row" alignItems="center" gap={1.5}>
                    <Typography variant="textXS" color="#14181F" component="span">
                      <Typography variant="footnoteRegular" color="#000000" component="span">
                        •{' '}
                      </Typography>
                      {content.text}
                    </Typography>

                    {content.showIcon && (
                      <Box component="img" src={FrameSvg} alt="Bullet Icon" sx={{ width: 12, height: 12 }} />
                    )}
                  </Grid>
                  <div style={{ height: '0.5px', backgroundColor: '#DCE0E5', width: '100%' }} />
                </>
              ))}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}

export default PlanDetails;
